import { env } from "@/env";
import { adminClient, inferAdditionalFields } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: env.VITE_BETTER_AUTH_URL,
  plugins: [
    adminClient(),
    inferAdditionalFields({
      user: {
        requiresPasswordChange: {
          type: "boolean",
        },
      },
    }),
  ],
});

export type Session = typeof authClient.$Infer.Session;
export type User = Session["user"];
